// extracted by mini-css-extract-plugin
export default {"ootagsInput":"colorInput_ootagsInput__L8U9I","ootags":"colorInput_ootags__ZkHxY","ootag":"colorInput_ootag__6I2Qe","ootagCloseIcon":"colorInput_ootagCloseIcon__MpwPM"};